/* eslint-disable no-useless-catch */
interface IPreSignupFormInputs {
  firstName: string
  lastName: string
  phone: string
  cnpj: string
  businessType: string
}

const API_URL = 'https://clubbi.app.n8n.cloud/webhook/881a54de-3742-4c04-ae53-2fec3201ee45'

export const submitPreSignup = async (data: IPreSignupFormInputs): Promise<void> => {
  const payload = {
    first_name: data.firstName,
    last_name: data.lastName,
    phone_number: data.phone.replace(/\D/g, ''),
    cnpj: data.cnpj.replace(/\D/g, ''),
    business_type: data.businessType,
  }

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      const errorData = await response.json()
      const errorMessage = errorData?.message || `Falha no cadastro (Status ${response.status}).`
      throw new Error(errorMessage)
    }
  } catch (error) {
    throw error
  }
}
